import { render, staticRenderFns } from "./OrderDetailSidebar.vue?vue&type=template&id=441bae10"
import script from "./OrderDetailSidebar.vue?vue&type=script&lang=js"
export * from "./OrderDetailSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports